export default __webpack_public_path__ + "static/media/quiet.7dc40507.jpg";